var customTableManager = function () {
    function init() {

        $(document).ready(function () {
            var customTables = $('.custom-table-component.pagination')
            if (customTables.length <= 0 || ENV.isEditmode){
                return;
            }

            customTables.each(function () {
                var currentComponent = $(this);
                var currentPage = 1;
                var tableColumn = $('.table-columns', currentComponent);
                var $pagination = $('.navigation-wrapper .table-pagination', tableColumn);
                var dataRowsContainer = $('.table-wrapper .data-rows-container', tableColumn);
                var tableRows = dataRowsContainer.find('tr');
                var elementsPerPage = dataRowsContainer.data('elements-per-page');
                var numberOfClicks = 0;
                var $paginationOption = {
                    firstClass: 'd-none invisible',
                    lastClass: 'd-none invisible',
                    prev: '<i class="prev-icon"></i>',
                    next: '<i class="next-icon"></i>',
                    totalPages: (Math.ceil(tableRows.length/elementsPerPage)),
                    hideOnlyOnePage: true,
                    initiateStartPageClick: true,
                    onPageClick: function (event, page) {
                        if (currentPage !== page || numberOfClicks===0) {
                            tableRows.addClass('d-none')
                            var minIndex = elementsPerPage*(page-1);
                            var maxIndex = ((elementsPerPage+minIndex)<tableRows.length)? (elementsPerPage+minIndex) : tableRows.length;
                            for (let i = minIndex; i < maxIndex; i++) {
                                $(tableRows[i]).removeClass('d-none')
                            }
                            if (numberOfClicks!==0){
                                $('html, body').animate({
                                    scrollTop: currentComponent.offset().top
                                }, 1000);
                            }
                            currentPage = page;
                            numberOfClicks++;
                        }

                        stockSearchManager.handlePageItems(currentComponent.find($(event.target)))
                    }
                }
                $pagination.twbsPagination($paginationOption);
            })
        });
    }

    return {init:init};
}(jQuery);